/* tslint:disable */
/* eslint-disable */
/**
 * CyberWell Aegis API
 * Multi-tenant case management API with JWT auth, RBAC (Casbin), audit logging, and tenant isolation.
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';

export interface EnableDebugLoggingRequest {
    sessionId?: string;
}

export interface EnableInfoLoggingRequest {
    sessionId?: string;
}

export interface GetLoggingLevelsRequest {
    sessionId?: string;
}

export interface GetLoggingStatisticsRequest {
    sessionId?: string;
}

export interface ResetLoggingLevelsRequest {
    sessionId?: string;
}

export interface SetLoggingLevelRequest {
    loggerName: string;
    level: string;
    sessionId?: string;
}

/**
 * LoggingManagementApi - interface
 * 
 * @export
 * @interface LoggingManagementApiInterface
 */
export interface LoggingManagementApiInterface {
    /**
     * Quickly enable debug logging for the entire application
     * @summary Set application logging to DEBUG
     * @param {string} [sessionId] Session ID for authorization
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LoggingManagementApiInterface
     */
    enableDebugLoggingRaw(requestParameters: EnableDebugLoggingRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<{ [key: string]: any; }>>;

    /**
     * Quickly enable debug logging for the entire application
     * Set application logging to DEBUG
     */
    enableDebugLogging(requestParameters: EnableDebugLoggingRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<{ [key: string]: any; }>;

    /**
     * Quickly disable debug logging for the entire application
     * @summary Set application logging to INFO
     * @param {string} [sessionId] Session ID for authorization
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LoggingManagementApiInterface
     */
    enableInfoLoggingRaw(requestParameters: EnableInfoLoggingRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<{ [key: string]: any; }>>;

    /**
     * Quickly disable debug logging for the entire application
     * Set application logging to INFO
     */
    enableInfoLogging(requestParameters: EnableInfoLoggingRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<{ [key: string]: any; }>;

    /**
     * Retrieves current logging levels for the application
     * @summary Get current logging levels
     * @param {string} [sessionId] Session ID for authorization
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LoggingManagementApiInterface
     */
    getLoggingLevelsRaw(requestParameters: GetLoggingLevelsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<{ [key: string]: any; }>>;

    /**
     * Retrieves current logging levels for the application
     * Get current logging levels
     */
    getLoggingLevels(requestParameters: GetLoggingLevelsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<{ [key: string]: any; }>;

    /**
     * Get statistics about current logging configuration
     * @summary Get logging statistics
     * @param {string} [sessionId] Session ID for authorization
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LoggingManagementApiInterface
     */
    getLoggingStatisticsRaw(requestParameters: GetLoggingStatisticsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<{ [key: string]: any; }>>;

    /**
     * Get statistics about current logging configuration
     * Get logging statistics
     */
    getLoggingStatistics(requestParameters: GetLoggingStatisticsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<{ [key: string]: any; }>;

    /**
     * Reset all logging levels to their default values
     * @summary Reset logging levels
     * @param {string} [sessionId] Session ID for authorization
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LoggingManagementApiInterface
     */
    resetLoggingLevelsRaw(requestParameters: ResetLoggingLevelsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<{ [key: string]: any; }>>;

    /**
     * Reset all logging levels to their default values
     * Reset logging levels
     */
    resetLoggingLevels(requestParameters: ResetLoggingLevelsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<{ [key: string]: any; }>;

    /**
     * Sets the logging level for a specific logger
     * @summary Set logging level
     * @param {string} loggerName Logger name
     * @param {string} level Logging level (DEBUG, INFO, WARN, ERROR)
     * @param {string} [sessionId] Session ID for authorization
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LoggingManagementApiInterface
     */
    setLoggingLevelRaw(requestParameters: SetLoggingLevelRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<{ [key: string]: any; }>>;

    /**
     * Sets the logging level for a specific logger
     * Set logging level
     */
    setLoggingLevel(requestParameters: SetLoggingLevelRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<{ [key: string]: any; }>;

}

/**
 * 
 */
export class LoggingManagementApi extends runtime.BaseAPI implements LoggingManagementApiInterface {

    /**
     * Quickly enable debug logging for the entire application
     * Set application logging to DEBUG
     */
    async enableDebugLoggingRaw(requestParameters: EnableDebugLoggingRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<{ [key: string]: any; }>> {
        const queryParameters: any = {};

        if (requestParameters['sessionId'] != null) {
            queryParameters['sessionId'] = requestParameters['sessionId'];
        }

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/v1/logging/debug`;

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse<any>(response);
    }

    /**
     * Quickly enable debug logging for the entire application
     * Set application logging to DEBUG
     */
    async enableDebugLogging(requestParameters: EnableDebugLoggingRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<{ [key: string]: any; }> {
        const response = await this.enableDebugLoggingRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Quickly disable debug logging for the entire application
     * Set application logging to INFO
     */
    async enableInfoLoggingRaw(requestParameters: EnableInfoLoggingRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<{ [key: string]: any; }>> {
        const queryParameters: any = {};

        if (requestParameters['sessionId'] != null) {
            queryParameters['sessionId'] = requestParameters['sessionId'];
        }

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/v1/logging/info`;

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse<any>(response);
    }

    /**
     * Quickly disable debug logging for the entire application
     * Set application logging to INFO
     */
    async enableInfoLogging(requestParameters: EnableInfoLoggingRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<{ [key: string]: any; }> {
        const response = await this.enableInfoLoggingRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Retrieves current logging levels for the application
     * Get current logging levels
     */
    async getLoggingLevelsRaw(requestParameters: GetLoggingLevelsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<{ [key: string]: any; }>> {
        const queryParameters: any = {};

        if (requestParameters['sessionId'] != null) {
            queryParameters['sessionId'] = requestParameters['sessionId'];
        }

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/v1/logging/levels`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse<any>(response);
    }

    /**
     * Retrieves current logging levels for the application
     * Get current logging levels
     */
    async getLoggingLevels(requestParameters: GetLoggingLevelsRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<{ [key: string]: any; }> {
        const response = await this.getLoggingLevelsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get statistics about current logging configuration
     * Get logging statistics
     */
    async getLoggingStatisticsRaw(requestParameters: GetLoggingStatisticsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<{ [key: string]: any; }>> {
        const queryParameters: any = {};

        if (requestParameters['sessionId'] != null) {
            queryParameters['sessionId'] = requestParameters['sessionId'];
        }

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/v1/logging/statistics`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse<any>(response);
    }

    /**
     * Get statistics about current logging configuration
     * Get logging statistics
     */
    async getLoggingStatistics(requestParameters: GetLoggingStatisticsRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<{ [key: string]: any; }> {
        const response = await this.getLoggingStatisticsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Reset all logging levels to their default values
     * Reset logging levels
     */
    async resetLoggingLevelsRaw(requestParameters: ResetLoggingLevelsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<{ [key: string]: any; }>> {
        const queryParameters: any = {};

        if (requestParameters['sessionId'] != null) {
            queryParameters['sessionId'] = requestParameters['sessionId'];
        }

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/v1/logging/reset`;

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse<any>(response);
    }

    /**
     * Reset all logging levels to their default values
     * Reset logging levels
     */
    async resetLoggingLevels(requestParameters: ResetLoggingLevelsRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<{ [key: string]: any; }> {
        const response = await this.resetLoggingLevelsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Sets the logging level for a specific logger
     * Set logging level
     */
    async setLoggingLevelRaw(requestParameters: SetLoggingLevelRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<{ [key: string]: any; }>> {
        if (requestParameters['loggerName'] == null) {
            throw new runtime.RequiredError(
                'loggerName',
                'Required parameter "loggerName" was null or undefined when calling setLoggingLevel().'
            );
        }

        if (requestParameters['level'] == null) {
            throw new runtime.RequiredError(
                'level',
                'Required parameter "level" was null or undefined when calling setLoggingLevel().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['loggerName'] != null) {
            queryParameters['loggerName'] = requestParameters['loggerName'];
        }

        if (requestParameters['level'] != null) {
            queryParameters['level'] = requestParameters['level'];
        }

        if (requestParameters['sessionId'] != null) {
            queryParameters['sessionId'] = requestParameters['sessionId'];
        }

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/v1/logging/level`;

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse<any>(response);
    }

    /**
     * Sets the logging level for a specific logger
     * Set logging level
     */
    async setLoggingLevel(requestParameters: SetLoggingLevelRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<{ [key: string]: any; }> {
        const response = await this.setLoggingLevelRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
